// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    width: 100%;
    height: 100%;
}

/* PWA specific style needed for iOS mostly */
@media all and (display-mode: standalone) {
    html {
        height: 100vh;
    }

    body {
        touch-action: none;
    }
}

html, body {
    font-family: AzeretMono-Regular, sans-serif;
    background: #36454f;
}

body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

#spinamp-root {
    width: 100%;
    height: 100%;
}

#spinamp-root > * {
    height: 100%;
}

input, textarea {
    outline: none !important;
}

textarea::-webkit-scrollbar {
    display: none;
}

/* make rainbow-kit wrapper full height */
html div[data-rk] {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

a,
a:link,
a:hover,
a:active,
a:visited,
a:focus {
    text-decoration: none;
    outline: none;
}

p {
    display: block;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
}

h1, h2 {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
}

ul {
    margin-block-start: 0.5em;
    margin-block-end: 0;
}

wcm-modal {
    /* display on above the react native modal */
    z-index: 10000;
}

iframe {
    border: none !important;
}

#spinamp-root {
    position: fixed;
    width: 100%;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./web/index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,6CAA6C;AAC7C;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA,yCAAyC;AACzC;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB","sourcesContent":["html {\n    width: 100%;\n    height: 100%;\n}\n\n/* PWA specific style needed for iOS mostly */\n@media all and (display-mode: standalone) {\n    html {\n        height: 100vh;\n    }\n\n    body {\n        touch-action: none;\n    }\n}\n\nhtml, body {\n    font-family: AzeretMono-Regular, sans-serif;\n    background: #36454f;\n}\n\nbody {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n\n#spinamp-root {\n    width: 100%;\n    height: 100%;\n}\n\n#spinamp-root > * {\n    height: 100%;\n}\n\ninput, textarea {\n    outline: none !important;\n}\n\ntextarea::-webkit-scrollbar {\n    display: none;\n}\n\n/* make rainbow-kit wrapper full height */\nhtml div[data-rk] {\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\na,\na:link,\na:hover,\na:active,\na:visited,\na:focus {\n    text-decoration: none;\n    outline: none;\n}\n\np {\n    display: block;\n    margin-block-start: 0;\n    margin-block-end: 0;\n    margin-inline-start: 0;\n    margin-inline-end: 0;\n}\n\nh1, h2 {\n    margin-block-start: 0;\n    margin-block-end: 0;\n    margin-inline-start: 0;\n    margin-inline-end: 0;\n}\n\nul {\n    margin-block-start: 0.5em;\n    margin-block-end: 0;\n}\n\nwcm-modal {\n    /* display on above the react native modal */\n    z-index: 10000;\n}\n\niframe {\n    border: none !important;\n}\n\n#spinamp-root {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
